'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class contractModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
		if (typeof this.late_payment_interest !== 'undefined' && !isNaN(this.late_payment_interest) && this.late_payment_interest > 0.03) {
			this.late_payment_interest = Number(parseFloat(this.late_payment_interest).toFixed(2));
		} else {
			this.late_payment_interest = Number(0.03);
		}
		this.in_euros = (this.in_euros == 1 || this.in_euros === true);
		if (typeof this.no_profit_rule === 'undefined' || this.no_profit_rule === '') {
			this.no_profit_rule = 'n/a';
		}
		this.liability_for_recoveries = (this.liability_for_recoveries == 1 || this.liability_for_recoveries === true);
	}
	
	
	getValue(name){
		switch(name){
			case 'created':
			case 'updated':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'status':
				return this.getClassifValue(name, 'contract_status');
			case 'coordinator_country_id':
				return this.getClassifValue(name, 'country');
			case 'in_euros':
				return this.getClassifValue(name, 'yesno');
			case 'apl_requested_amount':
			case 'wp_budget_total':
				return this.s('$filter')('currency')(this[name]);
			case 'payment_ceiling':
				const jsDataService = this.s('jsDataService');
				const paymentCeilingId = parseInt(jsDataService?.data?.item?.payment_ceiling_id, 10);
				const ceilingArray = jsDataService?.data?.cfgClassif?.ceiling;
				const ceilingObj = Array.isArray(ceilingArray) ? ceilingArray.find(c => parseInt(c.id, 10) === paymentCeilingId) : null;
				return ceilingObj?.title ? `${ceilingObj.title}%` : '0%';
			case 'late_payment_interest':
				return this[name];
			case 'liability_for_enforced_recoveries':
				return this.getClassifValue(name, 'liability_enrec');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}